export const CLEVER_URL = "https://listwithclever.com";
export const TERMS_URL = "https://listwithclever.com/terms-conditions/";
export const PRIVACY_URL = "https://listwithclever.com/privacy-policy/";
export const CONSENT_URL =
  "https://listwithclever.com/consent-to-contact-consumer/";
export const TREC_URL =
  "https://listwithclever.com/trec-consumer-protection-notice.pdf";
export const BROKERAGE_URL =
  "https://listwithclever.com/information-about-brokerage-services.pdf";
export const INVALID_EMAIL = "A valid email is required";
export const INVALID_FULL_NAME = "A first and last name are required";
export const INVALID_PHONE_NUMBER = "A valid phone number is required";
export const CLIENT_ID_HEADER = { "X-Client-Id": "clever-surveys" };
